import { render, staticRenderFns } from "./AddExpence.vue?vue&type=template&id=5e74d821&"
import script from "./AddExpence.vue?vue&type=script&lang=js&"
export * from "./AddExpence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports